"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileNav = void 0;
const mobileNav = () => {
    /**
     * Header and navigation hooks
     */
    const nav = document.querySelector('.navigation-panel');
    const navOpen = document.querySelector('[data-panel="open"]');
    const navClose = document.querySelector('[data-panel="close"]');
    const body = document.body;
    // const root: HTMLElement  = document.documentElement;
    navOpen.addEventListener('click', () => {
        nav.classList.add('is-open');
        navOpen.classList.add('is-active');
        body.classList.add('has-open-panel');
        nav.setAttribute('aria-hidden', 'false');
        nav.querySelectorAll("a, button").forEach((ele) => {
            ele.setAttribute("tabindex", "0");
        });
        // const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        // body.style.position = 'fixed';
        // body.style.top = `-${scrollY}`;
        // root.classList.remove('smooth-scroll');
    });
    navClose.addEventListener('click', () => {
        nav.classList.remove('is-open');
        navOpen.classList.remove('is-active');
        body.classList.remove('has-open-panel');
        nav.setAttribute('aria-hidden', 'true');
        // make links not tabbable
        nav.querySelectorAll("a, button").forEach((ele) => {
            ele.setAttribute("tabindex", "-1");
        });
        // const scrollY = body.style.top;
        // body.style.position = '';
        // body.style.top = '';
        // window.scrollTo(0, parseInt(scrollY || '0') * -1);
        // root.classList.add('smooth-scroll');
    });
    // window.addEventListener('scroll', () => {
    //   document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    // });
};
exports.mobileNav = mobileNav;
